import { defineStore } from 'pinia'
import toasteventbus from "primevue/toasteventbus";

export const useApiLogsStore = defineStore('apiLogs', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getApiLogs: (state) => state.data?.data,
  },
  actions: {
    async indexApiLogs(params = {}) {
      try {
        const response = await axios.get('api-logs', {params});
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showApiLog(apiLogId, params = {}) {
      try {
        const response = await axios.get(`api-logs/${ apiLogId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteApiLog(apiLogId) {
      try {
        await axios.delete(`api-logs/${ apiLogId }`);
        toasteventbus.emit('add', {
          title: 'API Log Deleted',
          text: 'The log entry has been deleted.',
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showApiLogSettings() {
      try {
        const response = await axios.get('api-logs/settings');
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async updateApiLogSettings(settings = {}) {
      try {
        const response = await axios.put('api-logs/settings', settings);
        toasteventbus.emit('add', {
          title: 'API Logging Updated',
          text: response.data.enabled ? 'API logging is now on.' : 'API logging is now off.',
          severity: 'success',
          life: 3000
        });
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    /**
     * Users available for the "user" filter. Kept here rather than in the
     * users store so that browsing logs does not disturb the users admin page.
     */
    async indexUserOptions(search = '') {
      try {
        const response = await axios.get('users', {
          params: {
            per_page: 50,
            sort: 'name',
            filter: search ? {search} : {},
          }
        });
        return response.data?.data ?? [];
      } catch (error) {
        console.error(error.response);
        return [];
      }
    },
  },
});
